export default (function (sdkModule) {
  return [];
});